export enum FlowDirections
{
    VERTICAL,
    HORIZONTAL
}